import { gql } from '@apollo/client'

const listVenueDevicesByEmail = gql(`
  query listVenueDevicesByEmail ($email: String!)
  {
    listVenueDevicesByEmail(
      email : $email
    ){
      success
      data {
        id
        email
        active
        name
        appVersion
        osVersion
        platformType
        description
        createdAt
        updatedAt,
        lastAppLaunchAt
      }
      error {
        code
        message
      }
    }
  }
`)

export default listVenueDevicesByEmail
